// Generic table column interface - matching your preferred structure
// import { TenantDTO } from "@surgia/api/src/dtos/tenant";
export interface TableColumn {
    key: string;
    translationKey: string;
    sortable: boolean; // Required, not optional
    sortType?: "string" | "number" | "date"; // Only needed if sortable is true
    sortKey?: string; // New: the actual field name to send to API for sorting
    align?: "left" | "right" | "center";
    render?: (value: any, row: any) => React.ReactNode;
    show?: boolean;
    headerIcon?: string; // New: icon to show in the header
  }
  
  // Generic table props - simplified
  export interface GenericTableProps {
    columns: TableColumn[];
    data: any[];
    loading?: boolean;
    currentPage?: number;
    totalPages?: number;
    rowsPerPage?: number;
    onPageChange?: (page: number) => void;
    actions?: (row: any) => React.ReactNode;
    // New sorting props
    sortState?: SortState;
    onSort?: (sortState: SortState) => void;
    enableInternalSorting?: boolean;
    idColumnIcon?: string;
  }


  // Class name constants - completely agnostic styling
export const headerCellClass =
    "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider whitespace-nowrap";
export const headerCellRightClass =
  "px-6 py-3 text-right text-xs font-medium text-gray-500 tracking-wider whitespace-nowrap";
export const headerCellCenterClass =
  "px-6 py-3 text-center text-xs font-medium text-gray-500 tracking-wider whitespace-nowrap";


  // Generic function to get header class based on alignment
  export const getHeaderClass = (align?: string) => {
    switch (align) {
      case "right":
        return headerCellRightClass;
      case "center":
        return headerCellCenterClass;
      default:
        return headerCellClass;
    }
  };

    // Generic function to get cell class based on alignment
    export const getCellClass = (align?: string) => {
        const baseClass = "px-6 py-4 whitespace-nowrap text-sm";
        switch (align) {
          case "right":
            return `${baseClass} text-right`;
          case "center":
            return `${baseClass} text-center`;
          default:
            return `${baseClass} text-left`;
        }
      };
//-----------------------------------------------------------/
export const getStatusVariant = (status: string): "active" | "pending" => {
    return status.toLowerCase() === "active" ? "active" : "pending";
  };
    // Business-specific helper functions

  
  // Business-specific props interface
  export interface TenantsTableProps {
    data: any;
    onActivate?: (id: string, tenantData: any) => void;
    onViewDetails?: (id: string,navigate?:any) => void;
    loading?: boolean;
    currentPage?: number;
    totalPages?: number;
    onPageChange?: (page: number) => void;
    dataType?: "tenants" | "requests";
    sortState?: SortState;
    onSort?: (sortState: SortState) => void;
  }

// Add to constants file
export interface SortState {
  column: string | null;
  direction: "asc" | "desc" | null;
}